import { Component, Prop, h } from '@stencil/core';
import { getConstant } from '../../../../../utils/constants-helpers';
import { parseJsonProp } from '../../../../../utils/helpers/hydration';

/**
 * Related links component for SignNow brand content links
 *
 * @product signnow
 * @source relinking
 * @version 1.0.2
 * @category links
 * @contentConfig Related links component for displaying related content links
 * @constant RELATED_LINKS_HEADING - "Get more for office signature feature" - Main heading for related links section
 * @slot heading - {required}, <me-heading variant="2"> - Main heading for related links section
 */
@Component({
  tag: 'sn-related-links-type-1',
  styleUrl: 'index.scss',
  shadow: false,
})
export class SNRelatedLinksType1 {
  /**
   * Component constants object containing all required text constants
   */
  @Prop({ mutable: true }) constants?: Record<string, string> | string;

  /**
   * HTML tag for the heading element (h1, h2, h3, h4, h5, h6)
   * @default "h3"
   */
  @Prop() headingTag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' = 'h3';

  /**
   * @dynamic
   * @type {array}
   * @.type {object}
   * @.property {string} link - Link URL
   * @.property {string} title - Link text
   * @.required link
   * @.required title
   * @minItems 1
   */
  @Prop({ mutable: true }) items!: any[] | string;

  private parsedLinks: any[] = [];

  componentWillLoad() {
    this.constants = parseJsonProp(this.constants);
    this.items = parseJsonProp(this.items, []);

    // Transform server format {link, title} to component format {href, label}
    this.parsedLinks = Array.isArray(this.items)
      ? this.items.map(item => ({
          href: item.href || item.link || '',
          label: item.label || item.title || '',
        }))
      : [];
  }

  render() {
    // Don't render if no links available
    if (!this.parsedLinks || this.parsedLinks.length === 0) {
      return null;
    }

    return (
      <related-links-type-1 links={this.parsedLinks} class="theme-brand-signnow">
        <me-heading slot="heading" align="center" variant="2" tag={this.headingTag}>
          {getConstant(this.constants, 'RELATED_LINKS_HEADING', 'Get more for online agreement signing pdf')}
        </me-heading>
      </related-links-type-1>
    );
  }
}
